export const gardenApiData = {
  'gardenColumnList': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '教改园地', '获取所有栏目'],
    title: '获取所有栏目', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取所有栏目', url: '/api/v1/invoke-v2/product/getAllColumns', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id ', type: 'Int', description: '栏目id' },
        { paras: 'name ', type: 'String', description: '栏目名称' },
        { paras: 'createdTime ', type: 'String', description: '创建时间' },
        { paras: 'modifiedTime ', type: 'String', description: '更新时间' },
        { paras: 'stageId ', type: 'Int', description: '栏目学段，2小学，3初中，4高中' },
        { paras: 'brandId ', type: 'Int', description: '品牌，0精品1易百2问鼎' }
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
      "code": 1,
      "msg": "成功",
      "data": [
        {
          "id": 1000036,
          "createdTime": "2023-09-12T11:29:30",
          "modifiedTime": "2023-09-12T12:00:38",
          "name": "新课堂 · 教",
          "stageId": 3,
          "sort": 1,
          "status": 1,
          "seriesId": 31,
          "author": "cm",
          "brandId": 0
        },
      ]
    }
    `
  },
  'gardenTopicList': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '教改园地', '获取栏目下专题'],
    title: '获取栏目下专题', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取栏目下专题', url: '/api/v1/invoke-v2/product/getAllTopics', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'columnId', type: 'Int', required: '必填', description: '专栏id' },
        { paras: 'stageId', type: 'Int', required: '必填', description: '学段id' },
        { paras: 'subjectId', type: 'Int', required: '必填', description: '学科id' },
        { paras: 'year', type: 'Int', required: '必填', description: '届别' },
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id ', type: 'Int', description: '专题id' },
        { paras: 'outsideName', type: 'String', description: '专题名称' },
        { paras: 'intro ', type: 'String', description: '简介' },
        { paras: 'year ', type: 'Int', description: '届别' },
        { paras: 'suitFor ', type: 'String', description: '适用范围' },
        { paras: 'suspensionDescription ', type: 'String', description: '悬浮简介' },
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
      "code": 1,
      "msg": "成功",
      "data": [
        {
          "name": "xxxxx",
          "id": 100000,
          "intro": "xxxxx",
          "year": 2024,
          "updateTime": null,
          "productCount": null,
          "isCollect": null,
          "status": null,
          "suitFor": "二轮复习",
          "outsideName": "xxxxx",
          "suspensionDescription": "xxxxx",
          "videoId": "",
          "hideItems": null,
          "yearMapId": null,
          "stageId": 3,
          "subjectIds": null,
          "stageName": null,
          "subjectName": null
        },
      ]
    }
    `
  },
  'gardenTopicInfo': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '教改园地', '获取专题基本信息'],
    title: '获取专题基本信息', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取专题基本信息', url: '/api/v1/invoke-v2/product/topicDetail', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'columnId', type: 'Int', required: '必填', description: '专栏id' },
        { paras: 'topicId', type: 'Int', required: '必填', description: '专题id' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id ', type: 'Int', description: '专题id' },
        { paras: 'outsideName', type: 'String', description: '专题名称' },
        { paras: 'intro ', type: 'String', description: '简介' },
        { paras: 'year ', type: 'Int', description: '届别' },
        { paras: 'suitFor ', type: 'String', description: '适用范围' },
        { paras: 'suspensionDescription ', type: 'String', description: '悬浮简介' },
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
      "code": 1,
      "msg": "成功",
      "data": {
        "name": "单元测试卷0202",
        "id": 1000105,
        "intro": "xxx",
        "year": 2024,
        "updateTime": null,
        "productCount": 12,
        "isCollect": null,
        "status": null,
        "suitFor": "二轮复习",
        "outsideName": "单元测试卷0202",
        "suspensionDescription": "xxx",
        "videoId": "",
        "hideItems": "p",
        "yearMapId": {
          "2024": 1000105
        },
        "stageId": 3,
        "subjectIds": null,
        "stageName": null,
        "subjectName": null
      }
    }
    `
  },
  'gardenVersionList': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '教改园地', '获取专题下专辑版本'],
    title: '获取专题下专辑版本', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取专题下专辑版本', url: '/api/v1/invoke-v2/product/versions', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'topicId', type: 'Int', required: '必填', description: '专题id' },
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id', type: 'Int', description: '版本id（空数组表示当前专题下专辑无版本标签）' },
        { paras: 'name', type: 'String', description: '版本名称' }
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
      "code": 1,
      "msg": "成功",
      "data": [
        {
          "id": 709,
          "name": "部编版（五四制）",
          "bookFlag": null
        }
      ]
    }
    `
  },
  'gardenTextbookList': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '教改园地', '获取专题下专辑册别'],
    title: '获取专题下专辑册别', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取专题下专辑册别', url: '/api/v1/invoke-v2/product/textbooks', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'versionId', type: 'Int', required: '必填', description: '版本id' },
        { paras: 'topicId', type: 'Int', required: '必填', description: '专题id' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id', type: 'Int', description: '册别id（空数组表示当前专题下专辑无册别标签）' },
        { paras: 'name', type: 'String', description: '册别名称' }
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
      "code": 1,
      "msg": "成功",
      "data": [
        {
          "id": 4456,
          "name": "九年级上册"
        }
      ]
    }
    `
  },
  'gardenProvinceList': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '教改园地', '获取专题下专辑地区'],
    title: '获取专题下专辑地区', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取专题下专辑地区', url: '/api/v1/invoke-v2/product/provinces', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'topicId', type: 'Int', required: '必填', description: '专题id' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id', type: 'Int', description: '地区id（空数组表示当前专题下专辑无地区标签）' },
        { paras: 'name', type: 'String', description: '地区名称' }
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
      "code": 1,
      "msg": "成功",
      "data": [
        {
          "id": 110000,
          "name": "北京"
        },
      ]
    }
    `
  },
  'gardenDifficultyList': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '教改园地', '获取专题下专辑难易'],
    title: '获取专题下专辑难易', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取专题下专辑难易', url: '/api/v1/invoke-v2/product/difficulty', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'topicId', type: 'Int', required: '必填', description: '专题id' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id', type: 'Int', description: '难易id（空数组表示当前专题下专辑无难易标签）' },
        { paras: 'name', type: 'String', description: '难易' }
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
      "code": 1,
      "msg": "成功",
      "data": 	{
        "id": 0,
        "name": "容易"
      },
      {
        "id": 1,
        "name": "困难"
      }
    }
    `
  },
  'gardenAlbumList': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '教改园地', '获取专题下专辑列表'],
    title: '获取专题下专辑列表', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取专题下专辑列表', url: '/api/v1/invoke-v2/product/queryProductList', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'topicId', type: 'Int', required: '必填', description: '专题id' },
        { paras: 'versionId', type: 'Int', required: '非必填', description: '版本id' },
        { paras: 'textbookId', type: 'Int', required: '非必填', description: '册别id' },
        { paras: 'provinceId', type: 'Int', required: '非必填', description: '地区id' },
        { paras: 'difficulty', type: 'Int', required: '非必填', description: '难易id' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id ', type: 'Int', description: '专辑id' },
        { paras: 'name ', type: 'String', description: '专辑名称' },
        { paras: 'updateTime ', type: 'String', description: '更新时间' },
        { paras: 'stageId ', type: 'Int', description: '学段id' },
        { paras: 'difficulty ', type: 'Int', description: '所属难易' },
        { paras: 'textbooks ', type: 'Array', description: '所属版本册别， basicVersionId版本，textbookId册别' },
        { paras: 'subjects ', type: 'Array', description: '所属学科' },
        { paras: 'provinces ', type: 'Array', description: '所属地区' },
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
      "code": 1,
      "msg": "成功",
      "data": [
        {
          "id": 1000173,
          "name": "xxxx",
          "stageId": 3,
          "stageName": "初中",
          "intro": "",
          "fileAddress": "",
          "status": 0,
          "modifiedTime": "2023-10-18",
          "updateTime": "2023-09-15",
          "viewCount": 4,
          "downloadCount": 158,
          "author": "xxx",
          "uid": 124,
          "sort": 10,
          "difficulty": 0,
          "textbooks": [],
          "subjects": [
            {
              "id": 10,
              "name": "语文"
            }
          ],
          "provinces": [],
          "collection": false
        },
      ]
    }
    `
  },
  'gardenAlbumDoc': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '专辑资源', '获取专辑文档'],
    title: '获取专辑文档', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取专辑文档', url: '/api/v1/invoke-v2/product/resourceLinks', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'productId', type: 'Int', required: '必填', description: '专辑id' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'catalogueName', type: 'String', description: '目录名称' },
        { paras: 'resourceLinkS', type: 'Array', description: '目录下文档' },
        { paras: 'resourceLinkS/documentId', type: 'Int', description: '文档id' },
        { paras: 'resourceLinkS/name', type: 'String', description: '文档名称' },
        { paras: 'resourceLinkS/suffixType', type: 'String', description: '文档格式' },
        { paras: 'resourceLinkS/size', type: 'Int', description: '文档大小kb' }
      ],
    },
    showResponseCode: true,
    responseCode: `
    {
      "id": null,
      "parentId": null,
      "productId": null,
      "ordinal": null,
      "catalogueName": "全部",
      "depth": null,
      "children": [],
      "resourceLinkS": [
        {
          "linkId": 1000419,
          "catalogueId": 0,
          "productId": 1000174,
          "documentId": 8907980,
          "name": "古诗词诵读《虞美人》课件48张 2022-2023学年统编版高中语文必修上册",
          "suffixType": "pptx",
          "downloadIntegral": null,
          "updateTime": "2023-10-16",
          "size": 12234,
          "ordinal": 34,
          "download": 0,
          "downloadNum": 12,
          "viewNum": 28,
          "videoId": null
        }
      ]
    }
    `
  },
  'gardenAlbumInfo': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '教改园地', '获取专辑详情（文档）'],
    title: '获取专辑详情（文档）', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取专辑详情', url: '/api/v1/invoke-v2/product/getProductInfo', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'productId', type: 'Int', required: '必填', description: 'id' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id ', type: 'Int', description: '专辑id' },
        { paras: 'name ', type: 'String', description: '专辑名称' },
        { paras: 'updateTime ', type: 'String', description: '更新时间' },
        { paras: 'stageId ', type: 'Int', description: '学段id' },
        { paras: 'difficulty ', type: 'Int', description: '所属难易' },
        { paras: 'textbooks ', type: 'Array', description: '所属版本册别， basicVersionId版本，textbookId册别' },
        { paras: 'subjects ', type: 'Array', description: '所属学科' },
        { paras: 'provinces ', type: 'Array', description: '所属地区' },
        { paras: 'specialTopicId ', type: 'Array', description: '所属专题id' },
        { paras: 'specialTopicName ', type: 'Array', description: '所属专题name' },
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
      "code": 1,
      "msg": "成功",
      "data": {
        "id": 1000174,
        "name": "小苹果专辑02",
        "stageId": 3,
        "stageName": "初中",
        "intro": "",
        "fileAddress": "",
        "status": 0,
        "modifiedTime": "2023-10-18",
        "updateTime": "2023-10-18",
        "viewCount": 1,
        "downloadCount": 5,
        "documentCount": 8,
        "author": "xxx",
        "uid": 124,
        "specialTopicId": 1000105,
        "specialTopicName": "单元测试卷0202",
        "difficulty": 0,
        "textbooks": [
          {
            "basicVersionId": 405,
            "basicVersionName": "部编版",
            "textbookId": 4456,
            "textbookName": "九年级上册"
          }
        ],
        "subjects": [
          {
            "id": 10,
            "name": "语文"
          }
        ],
        "provinces": [
          {
            "id": 120000,
            "name": "天津"
          },
          {
            "id": 140000,
            "name": "山西省"
          }
        ],
        "collection": false
      }
    }
    `
  },
  'gardenAlbumPreview': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '教改园地', '文档预览'],
    title: '文档预览', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '文档预览', url: '/api/v1/invoke-v2/product/documentPreview', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'documentId', type: 'Int', required: '必填', description: '文档id' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'data ', type: 'Array', description: '图片数据，zip资料长度为zip内文档数量，非zip文档长度为1，空数组表示未解压或未转码文档' },
        { paras: 'status ', type: 'String', description: '是否完成转换为图片，Finished表示完成转换，其他表示转码中' },
        { paras: 'pictureUrls ', type: 'Array', description: '文档图片地址' },
        { paras: 'picsCount ', type: 'Int', description: '文档图片总数量' },
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
      "code": 1,
      "msg": "成功",
      "data": [
        {
          "documentId": 8906328,
          "id": 1800,
          "type": null,
          "size": 1092,
          "suffixType": "pptx",
          "fileAddress": "{%uploaddir%}unzipFile/20230302-1677722209700l98lqdib/小学-北师大版2001二年级上册同步备课1204-01.pptx",
          "status": "Finished",
          "pictureUrls": [
              "http://jty-online-preview-new.obs.cn-north-4.myhuaweicloud.com/unzipFile/20230302-1677722209700l98lqdib/%E5%B0%8F%E5%AD%A6-%E5%8C%97%E5%B8%88%E5%A4%A7%E7%89%882001%E4%BA%8C%E5%B9%B4%E7%BA%A7%E4%B8%8A%E5%86%8C%E5%90%8C%E6%AD%A5%E5%A4%87%E8%AF%BE1204-01/1.png?Expires=1684981457&OSSAccessKeyId=LTAI5tJ94NZBMdYjreZXXgFh&Signature=Qg%2FYtjv4HxYr9a4JEWl8Akskizw%3D",
              "http://jty-online-preview-new.obs.cn-north-4.myhuaweicloud.com/unzipFile/20230302-1677722209700l98lqdib/%E5%B0%8F%E5%AD%A6-%E5%8C%97%E5%B8%88%E5%A4%A7%E7%89%882001%E4%BA%8C%E5%B9%B4%E7%BA%A7%E4%B8%8A%E5%86%8C%E5%90%8C%E6%AD%A5%E5%A4%87%E8%AF%BE1204-01/2.png?Expires=1684981457&OSSAccessKeyId=LTAI5tJ94NZBMdYjreZXXgFh&Signature=OzkFfPdEYT5nx4mOO8uAdh6Beog%3D",
              "http://jty-online-preview-new.obs.cn-north-4.myhuaweicloud.com/unzipFile/20230302-1677722209700l98lqdib/%E5%B0%8F%E5%AD%A6-%E5%8C%97%E5%B8%88%E5%A4%A7%E7%89%882001%E4%BA%8C%E5%B9%B4%E7%BA%A7%E4%B8%8A%E5%86%8C%E5%90%8C%E6%AD%A5%E5%A4%87%E8%AF%BE1204-01/3.png?Expires=1684981457&OSSAccessKeyId=LTAI5tJ94NZBMdYjreZXXgFh&Signature=TAkJCUfggK66rI1DHFiHPlD3JzM%3D"
          ],
          "isAllPics": false,
          "picsCount": 42
        }
      ]
    }
    `
  },
  'gardenAlbumDownload': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '教改园地', '文档下载'],
    title: '文档下载', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '文档下载', url: '/api/v1/invoke-v2/product/getDownloadInfo', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'documentId', type: 'Int', required: '必填', description: '文档id' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'downloadUrl', type: 'String', description: '文档url' },
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
      "code": 1,
      "msg": "成功",
      "data": {
        "documentId": 8907981,
        "downloadUrl": "https://jty-document-new.obs.cn-north-4.myhuaweicloud.com/2023/10/16/16974430125035jz62seip6.docx?Expires=1701330090&OSSAccessKeyId=LTAI5tJ94NZBMdYjreZXXgFh&Signature=gsEFu1JA9%2BusrrYbK81eG6PPSaQ%3D&response-content-disposition=%20attachment%3B%20filename%3D%22%25E5%258F%25AA%25E6%259C%2589%25E4%25B8%2580%25E9%2581%2593%25E9%25A2%2598%2520%281%29.docx%22&response-content-type=application%2Fvnd.openxmlformats-officedocument.wordprocessingml.document"
      }
    }
    `
  },
}



// WEBPACK FOOTER //
// ./src/pages/front/documentV2/gardenApiData.js